import { getConsultedYearRange, isConsultingOtherYear } from "@/services/schoolService";
import { monthLabel } from "@/services/payrollService";
import { formatDate, todayISO } from "@/utils/format";

/** Période d'affichage des opérations : tout, un mois, ou l'intervalle entre deux dates (incluses). */
export interface Period {
  mode: "all" | "month" | "range";
  /** AAAA-MM (mode « month »). */
  month: string;
  /** AAAA-MM-JJ, vides = sans borne (mode « range »). */
  from: string;
  to: string;
}

export const ALL_PERIOD: Period = { mode: "all", month: todayISO().slice(0, 7), from: "", to: "" };

/** La date (AAAA-MM-JJ) est-elle dans la période ? */
export function inPeriod(date: string, period: Period): boolean {
  if (period.mode === "month") return date.slice(0, 7) === period.month;
  if (period.mode === "range") {
    const day = date.slice(0, 10);
    return (!period.from || day >= period.from) && (!period.to || day <= period.to);
  }
  return true;
}

/** Libellé lisible de la période (sous les totaux). */
export function periodLabel(period: Period): string {
  if (period.mode === "month") return monthLabel(period.month);
  if (period.mode === "range") {
    if (period.from && period.to) return `du ${formatDate(period.from)} au ${formatDate(period.to)}`;
    if (period.from) return `depuis le ${formatDate(period.from)}`;
    if (period.to) return `jusqu'au ${formatDate(period.to)}`;
  }
  return "toutes périodes";
}


/** Du premier au dernier jour du mois en cours. */
export function currentMonthRange(): Period {
  const today = todayISO();
  const [year, month] = today.split("-").map(Number);
  const last = new Date(year, month, 0).getDate();
  const prefix = today.slice(0, 7);
  return { mode: "range", month: prefix, from: `${prefix}-01`, to: `${prefix}-${String(last).padStart(2, "0")}` };
}

/** Période par défaut des rapports : le mois en cours, ou toute l'année scolaire consultée si ce n'est pas l'année active. */
export function defaultPeriod(): Period {
  const range = isConsultingOtherYear() ? getConsultedYearRange() : null;
  return range ? { mode: "range", month: range.from.slice(0, 7), from: range.from, to: range.to } : currentMonthRange();
}
